import { gridItems } from "@/data";
import { BentoGrid, BentoGridItem } from "./ui/BentoGrid";

const Grid = () => {
  return (
    <section id="about" className="relative py-20">
      <div className="absolute inset-0 bg-grid-white/[0.05] [mask-image:radial-gradient(ellipse_at_center,white_30%,transparent_80%)] pointer-events-none" />

      <div className="relative z-10">
        <h2 className="heading">
          About <span className="text-purple">Me</span>
        </h2>
        <p className="text-white-200 text-center mt-4 max-w-3xl mx-auto">
          A premium snapshot of my profile, experience, education, and product
          focus.
        </p>

        <BentoGrid className="w-full mt-12">
          {gridItems.map((item, i) => (
            <BentoGridItem
              id={item.id}
              key={i}
              title={item.title}
              subtitle={item.subtitle}
              description={item.description}
              className={item.className}
              img={item.img}
              imgClassName={item.imgClassName}
            />
          ))}
        </BentoGrid>
      </div>
    </section>
  );
};

export default Grid;
